module.exports = __webpack_public_path__ + "static/media/wheel.1de149d6.gif";